import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import moment from "moment";
import clsx from "clsx";

export default function NonAdminAction(props) {
  const { classes, handleChange, scaling_actions } = props;

  return (
    <Grid container direction="column" spacing={1}>
      <Grid
        item
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.headerWrapper}
      >
        <Grid item>
          <Typography variant="h6"> Actions </Typography>{" "}
        </Grid>{" "}
      </Grid>
      <Grid
        item
        container
        direction="column"
        className={clsx({
          [classes.tableWrapper]: scaling_actions.length > 0,
        })}
      >
        {scaling_actions.map((action, index) => (
          <Grid
            key={index}
            item
            container
            alignItems="center"
            justifyContent="space-between"
            className={clsx(classes.actionWrapper, {
              [classes.actionSeperator]: index > 0,
            })}
          >
            <Grid item xs={11} container direction="column">
              {" "}
              {/* TextField: Created At */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Created At{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    id={String(index)}
                    name="created_at"
                    InputProps={{
                      readOnly: true,
                    }}
                    value={moment(action.created_at).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )}
                    onChange={handleChange}
                  />{" "}
                </Grid>{" "}
              </Grid>
              {/* TextField: Completed At */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Completed At{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    id={String(index)}
                    name="completed_at"
                    InputProps={{
                      readOnly: true,
                    }}
                    value={moment(action.completed_at).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )}
                    onChange={handleChange}
                  />{" "}
                </Grid>{" "}
              </Grid>
              {/* TextField: Actions */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Actions{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    multiline
                    id={String(index)}
                    name="actions"
                    InputProps={{
                      readOnly: true,
                    }}
                    value={action.actions}
                  />{" "}
                </Grid>{" "}
              </Grid>
              {/* TextField: Action Status */}{" "}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={2} className={classes.label}>
                  <Typography variant="body1" align="right">
                    Status{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    required
                    select
                    SelectProps={{
                      native: true,
                    }}
                    id={String(index)}
                    name="status"
                    value={action.status}
                    onChange={handleChange}
                  >
                    {["PENDING", "COMPLETE"].map((value, index) => (
                      <option key={index} value={value}>
                        {" "}
                        {value}{" "}
                      </option>
                    ))}{" "}
                  </TextField>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ))}{" "}
      </Grid>{" "}
    </Grid>
  );
}
